import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass';
import { Text } from '@tcaster/tcaster-web-lib';

const renderItemDefault = data => <div>{JSON.stringify(data)}</div>;
const EmptyViewDefault = ({ emptyText }) => (
  <Box>
    <Text>{emptyText}</Text>
  </Box>
);
class GridList extends Component {
  static propTypes = {
    renderItem: PropTypes.func,
    data: PropTypes.array.isRequired,
    idKey: PropTypes.string,
    onClick: PropTypes.func,
    as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
    columns: PropTypes.number,
    flexProps: PropTypes.shape({}),
    emptyView: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
    emptyText: PropTypes.string,
  };

  static defaultProps = {
    idKey: 'id',
    renderItem: renderItemDefault,
    as: 'a',
    columns: 2,
    flexProps: {},
    emptyView: EmptyViewDefault,
    emptyText: 'ไม่มีข้อมูล',
  };

  renderItem(data, index) {
    const { idKey, columns, onClick, as } = this.props;
    const item = this.props.renderItem(data, index);
    const key = data[idKey];

    const AsElem = as;

    return (
      <Box key={key} width={[1, 1 / columns]} pb={3}>
        {!onClick && React.cloneElement(item, { key })}
        {onClick &&
          React.createElement(
            AsElem,
            {
              key,
              onClick: e => {
                onClick(key, index, data);
                e.preventDefault();
              },
            },
            item,
          )}
      </Box>
    );

    // return React.createElement(
    //   AsElem,
    //   {
    //     key,
    //     onClick: e => {
    //       onClick(key, index, data);
    //       e.preventDefault();
    //     },
    //   },
    //   item
    // );
  }

  render() {
    const { data, flexProps, emptyText, emptyView } = this.props;
    return (
      <Flex flexWrap="wrap" {...flexProps}>
        {data.length > 0 && data.map((singleData, index) => this.renderItem(singleData, index))}
        {data.length === 0 && (
          <Flex flexDirection="row" justifyContent="center" style={{ width: '100%' }}>
            {React.createElement(emptyView, { emptyText })}
          </Flex>
        )}
      </Flex>
    );
  }
}

export default GridList;
